/**
 * Shared constants for change type visual treatment.
 */

import type { BadgeColor } from '@/components/ui/catalyst/badge';
import type { ChangeType } from '@/services/api/generated/crossMatterChangesService';

export const CHANGE_TYPE_CONFIG: Record<
  ChangeType,
  { label: string; color: BadgeColor }
> = {
  CREATED: { label: 'Created', color: 'green' },
  UPDATED: { label: 'Updated', color: 'blue' },
  DELETED: { label: 'Deleted', color: 'red' },
  SAME: { label: 'Same', color: 'zinc' },
};

export const CHANGE_TYPE_BORDER: Record<ChangeType, string> = {
  CREATED: 'border-l-green-400',
  UPDATED: 'border-l-blue-400',
  DELETED: 'border-l-red-400',
  SAME: '',
};

export const CHANGE_TYPE_ORDER: Record<ChangeType, number> = {
  CREATED: 0,
  UPDATED: 1,
  DELETED: 2,
  SAME: 3,
};

export const STATUS_COLORS: Record<string, BadgeColor> = {
  NEEDS_APPROVAL: 'amber',
  APPROVED: 'green',
  REJECTED: 'red',
};
